// eslint-disable-next-line
/**
 * Legacy helper — prefer `toNationalDigits` / `toApiPhoneNumber` from util/phoneNumber.
 * Strips leading "+" and zeros only (no Egypt-specific dial-code stripping).
 */
export const rawPhoneNumber = (phone) => phone.toString().replace(/^\+/, "").replace(/^0+/, "");

/**
 * Mapping of Arabic and Persian digits to English digits
 */
const ARABIC_TO_ENGLISH_DIGIT_MAP = {
  // Arabic Indic digits
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
};

/**
 * Convert input to English numbers
 * @param input - Original phone number input
 * @returns Converted phone number with only English digits
 *
 * Here are some example transformations:
 *
 *```
 * ٠١٢٣٤٥٦٧٨٩ → 0123456789
 * ١٢٣٤٥ → 12345
 * Hello ٤٥٦ → Hello 456
 * ```
 *
 */
export const convertToEnglishNumbers = (input) => {
  try {
    // Create a new variable to hold the input as a string.
    const inputStr = typeof input === "string" ? input : String(input);

    return inputStr
      .split("")
      .map((char) => ARABIC_TO_ENGLISH_DIGIT_MAP[char] || char)
      .join("");
  } catch (error) {
    // Optionally return the original input or a fallback value.
    return input;
  }
};
